import React from "react";

/**
 * ProgereTwoToneTitle — Style de titre PROGÈRE officiel.
 *
 * Rendu automatique si firstPart === "PROGÈRE" :
 *   PRO (or) + GÈRE (rouge) + secondPart (blanc/primary)
 *
 * Sinon fallback bicolore standard (firstPart color + secondPart color).
 */
export default function ProgereTwoToneTitle({
  firstPart,
  secondPart,
  firstColor = "var(--pg-gold)",
  secondColor = "var(--pg-text-primary)",
  size = "text-2xl",
  className = "",
  as = "h2",
}) {
  const Tag = as;
  const isProgereWord = (firstPart || "").toUpperCase() === "PROGÈRE";

  return (
    <Tag className={`font-heading font-black tracking-tight leading-tight ${size} ${className}`} data-testid="progere-two-tone-title">
      {isProgereWord ? (
        <>
          <span style={{ color: "var(--pg-gold)" }}>PRO</span>
          <span style={{ color: "var(--pg-red)" }}>GÈRE</span>
        </>
      ) : (
        <span style={{ color: firstColor }}>{firstPart}</span>
      )}
      {secondPart ? (
        <>
          {" "}
          <span style={{ color: secondColor }}>{secondPart}</span>
        </>
      ) : null}
    </Tag>
  );
}
